import { UsageTrackerProvider } from 'marketplace-ui-tracking';
import { SearchResultViewTracker } from 'marketplace-ui-tracking/events/marketplace';
import { combineTrackingProps } from '../../utils/trackingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceCardBase({
  children,
  componentType,
  listing,
  tracker,
  trackingProps
}) {
  const isolatedTracker = tracker.clone({
    standalone: true,
    preserveTrackerProperties: false
  });
  return /*#__PURE__*/_jsx(UsageTrackerProvider, {
    tracker: isolatedTracker,
    children: /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, combineTrackingProps({
      componentType,
      listing,
      trackingProps
    }), {
      children: children
    }))
  });
}